import React, { useEffect, useState } from "react";
import { faCheck, faExclamationTriangle, faFilePdf, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Form, Row } from "react-bootstrap";
import './styles.css'
import ReactTooltip from "react-tooltip";
import { useForm } from "react-hook-form";
import { Icon } from '@iconify/react';
import sendOutlined from '@iconify-icons/ant-design/send-outlined';
import DommusToggle from "../DommusToggle";
import Anexos from "../Anexos";
import caAPI from "../../services/caAPI";
import Swal from "sweetalert2";
import { trackPromise } from "react-promise-tracker";
import {isMobile} from 'react-device-detect';

function formatarNomeArquivo(nome) {
    if (!nome) return ''
    let nomeFormatado = nome
    if (nome.length > 61) {
        let extensao = nomeFormatado.split('.').at(-1)
        nomeFormatado = `${nomeFormatado.substring(0, 23)}...${extensao}`
    }
    return nomeFormatado
}

function AudioCard({ arquivo, selecionado, registerProps, onExcluir }) {
    return <div
        className={`cardAudio card${selecionado ? ' cardAudio--selecionado' : ''}`}
        data-tip={`${selecionado ? 'Desconsiderar' : 'Selecionar'} Áudio`}
    >
        <Form.Check
            type="checkbox"
            className="cardAudio__input-oculto"
            {...registerProps}
        />
        <div className="cardAudio__selecao">
            {selecionado && <FontAwesomeIcon icon={faCheck} className="cardAudio__check" />}
        </div>
        <div className="cardAudio__player">
            <audio controls>
                <source src={arquivo.link} />
            </audio>
        </div>
        {(arquivo.descricao || arquivo.nome) && (
            <div className="cardAudio__descricao">
                {arquivo.descricao || formatarNomeArquivo(arquivo.nome)}
            </div>
        )}
        <Button variant="danger" size="sm" className="cardAudio__btn-excluir" onClick={(event) => {
            event.stopPropagation()
            onExcluir(arquivo.id_arquivo_atendimento)
        }}>
            <FontAwesomeIcon icon={faTrashAlt} /> Excluir
        </Button>
    </div>
}

export function Galeria({ tipo, definirEstadoModal, enviarArquivos }) {
    const { register, setValue, handleSubmit, getValues } = useForm()
    const [toggleEnviarArquivosAberto, setToggleEnviarArquivosAberto] = useState(true)
    const [toggleSalvarArquivosAberto, setToggleSalvarArquivosAberto] = useState(true)
    const [atualizarTooltip, setAtualizarTooltip] = useState(false)
    const [arquivos, setArquivos] = useState([])
    const [arquivosSalvar, setArquivosSalvar] = useState([])
    const [descricaoAudio, setDescricaoAudio] = useState('')
    const [descricaoAudioInvalida, setDescricaoAudioInvalida] = useState(false)

    useEffect(() => {
        caAPI.arquivoAtendimento.buscar({ tipo })
            .then((response) => setArquivos(response.data))
            .catch(error => {
                console.log(error)
                console.log(error?.response?.data)
                Swal.fire('Ooops...', 'Houve um erro ao tentar buscar os arquivos.', 'error')
            })
    }, [])

    useEffect(() => {
        ReactTooltip.rebuild()
    }, [atualizarTooltip])

    function marcarDesmarcarArquivo(idArquivo) {
        const nome = resolverNomeFormulario(idArquivo)
        setValue(nome, !getValues(nome))
        setAtualizarTooltip(atualizarTooltip => !atualizarTooltip)
    }

    function resolverNomeFormulario(idArquivo) {
        return `${tipo}-${idArquivo}`
    }

    function salvarImagens() {
        if(!arquivosSalvar.length) {
            Swal.fire('Nenhum arquivo selecionado!', 'Selecione pelo o menos um arquivo antes de salvar.', 'warning')
            return
        }

        if(tipo === 'audio' && !descricaoAudio.trim()) {
            setDescricaoAudioInvalida(true)
            return
        }

        let promissesConverterConteudos = arquivosSalvar.map(arquivo => ({
            'nome': arquivo.nome,
            'tipo': tipo === 'audio' ? 'audio' : (arquivo.tipo == 'pdf' ? 'anexo' : 'imagem'),
            'conteudo': arquivo.conteudo,
            'extensao': arquivo.extensao,
            ...(tipo === 'audio' && { 'descricao': descricaoAudio.trim() }),
        }));

        trackPromise(caAPI.arquivoAtendimento.salvar(promissesConverterConteudos))
        .then((response) => {
            definirEstadoModal(false)
            setArquivosSalvar([])
            setDescricaoAudio('')
            setDescricaoAudioInvalida(false)
            Swal.fire('Sucesso!', 'Arquivos salvos com sucesso.', 'success').then(() => definirEstadoModal(true))
        }).catch(error => {
            console.log(error)
            console.log(error?.response?.data)
            Swal.fire('Ooops...', 'Houve um erro ao tentar salvar os arquivos.', 'error')
        })
    }

    function enviarArquivosSelecionados(arquivosSelecionados) {
        if (!arquivosSelecionados) {
            Swal.fire({
                titleText: "Atenção",
                text: `${tipo === 'imagem' ? 'Nenhuma imagem selecionada' : tipo === 'audio' ? 'Nenhum áudio selecionado' : 'Nenhum anexo selecionado'}`,
                icon: 'warning'
            });
            return;
        }
        const arquivosSelecionadosFiltrados = Object.entries(arquivosSelecionados).filter(([nome, selecionado]) => selecionado == true);
        const idsArquivosSelecionados = Object.values(arquivosSelecionadosFiltrados).map(arquivo => Number(arquivo[0].split('-')[1]))
        const arquivosSelecionadosTratados = arquivos.filter(arquivo => idsArquivosSelecionados.includes(arquivo.id_arquivo_atendimento))
        enviarArquivos(arquivosSelecionadosTratados)
        definirEstadoModal(false)
    }

    function excluirArquivo(idArquivo) {
        Swal.fire({
            titleText: "Deseja excluir o arquivo?",
            text: "Confime a realização da ação.",
            icon: "question",
            showCloseButton: false,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Não, mantenha.",
            customClass: {
              confirmButton: "btn btn-primary mr-3",
              cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
        }).then((result) => {
            if (!result.isConfirmed) {
                return
            }
            trackPromise(caAPI.arquivoAtendimento.excluir(idArquivo))
                .then(() => {
                    definirEstadoModal(false)
                    setArquivosSalvar([])
                    Swal.fire('Sucesso!', 'Arquivo excluído com sucesso.', 'success').then(() => definirEstadoModal(true))
                }).catch(error => {
                    console.log(error)
                    console.log(error?.response?.data)
                    Swal.fire('Ooops...', 'Houve um erro ao tentar excluir o arquivo.', 'error')
                })
        })
    }

    function Imagem({ arquivo }) {
        return (<>
            <div className="botoesEditarFoto">
                <div className="checkbox-imagem-galeria rounded py-1">
                    <Form.Check
                        type="checkbox"
                        className="p-0 m-0"
                        {...register(resolverNomeFormulario(arquivo.id_arquivo_atendimento))}
                        data-tip={`${getValues(resolverNomeFormulario(arquivo.id_arquivo_atendimento)) ? 'Desconsiderar' : 'Selecionar'} Imagem`}
                        style={{cursor: 'pointer'}}
                    />
                </div>
                {/* <Button
                    className="btn-sm btn-warning"
                    data-tip={`Enviar Imagem`}
                    style={{ backgroundColor: 'var(--dommus-color-2)' }}
                    onClick={(event) => event.stopPropagation()}
                >
                    <Icon icon={sendOutlined} color="white" />
                </Button> */}
                <Button className="btn-sm btn-danger" data-tip={`Excluir Imagem`} onClick={(event) => {
                    event.stopPropagation()
                    excluirArquivo(arquivo.id_arquivo_atendimento)
                }}>
                    <FontAwesomeIcon icon={faTrashAlt}/>
                </Button>
            </div>
            <img className="modalImgPortal" src={arquivo.link} alt="Arquivo para enviar no whatsapp" width={4} height={3}></img>
        </>)
    }

    function Anexo({ arquivo }) {
        return <div className="cardArquivo card" style={{cursor: 'pointer'}}>
            <Row className="justify-content-end px-3">
                <div
                    className="checkbox-anexo p-1 py-0 rounded"
                    style={{cursor: 'pointer'}}
                    data-tip={`${getValues(resolverNomeFormulario(arquivo.id_arquivo_atendimento)) ? 'Desconsiderar' : 'Selecionar'} Anexo`}
                >
                    <Form.Check
                        type="checkbox"
                        {...register(resolverNomeFormulario(arquivo.id_arquivo_atendimento))}
                        data-tip={`${getValues(resolverNomeFormulario(arquivo.id_arquivo_atendimento)) ? 'Desconsiderar' : 'Selecionar'} Anexo`}
                        style={{cursor: 'pointer'}}
                    />
                </div>
            </Row>
            <Row className="my-3 justify-content-center">
                <FontAwesomeIcon size="4x" color="#E75242" title="anexo" icon={faFilePdf} />
            </Row>
            <Row className="justify-content-center" style={{ fontSize: '0.8rem', minHeight: '5vh' }} data-tip={arquivo.nome}>
                {formatarNomeArquivo(arquivo.nome) || 'Anexo sem nome'}
            </Row>
            <Button
                className="mt-1 btn-sm"
                data-tip=""
                onClick={(event) => {
                event.stopPropagation()
                window.open(arquivo.link, '_blank')
            }}>
                Baixar
            </Button>
            <Button variant="danger" className="mt-1 btn-sm" data-tip="" onClick={(event) => {
                event.stopPropagation()
                excluirArquivo(arquivo.id_arquivo_atendimento)
            }}>
                Excluir
            </Button>
        </div>
    }


    return <Form onSubmit={handleSubmit(enviarArquivosSelecionados)}>
        <ReactTooltip effect="solid"/>
        <DommusToggle
            title={`Enviar ${tipo === 'imagem' ? 'Imagens' : tipo === 'audio' ? 'Áudios' : 'Anexos'}`}
            toggle={toggleEnviarArquivosAberto}
            className="labels"
            bodyClass="overflow-auto"
            callback={() => setToggleEnviarArquivosAberto(toggleAberto => !toggleAberto)}
        >
            {arquivos.length ? (<>
                <Row className={"justify-content-center" + ((isMobile && " fixed-height-attachment") || "")}>
                    {[...arquivos].sort((a, b) => a.nome > b.nome ? 1 : -1).map((arquivo) => (
                        <div
                          key={arquivo.id_arquivo_atendimento}
                          id={'divFotos-' + arquivo.id_arquivo_atendimento}
                          className={"divImg"}
                          onClick={() => marcarDesmarcarArquivo(arquivo.id_arquivo_atendimento)}
                          style={{ cursor: 'pointer' }}
                          data-tip={`${getValues(resolverNomeFormulario(arquivo.id_arquivo_atendimento)) ? 'Desconsiderar' : 'Selecionar'} ${tipo === 'imagem' ? 'Imagem' : tipo === 'audio' ? 'Áudio' : 'Anexo'}`}
                        >
                            {tipo === 'imagem' ? <Imagem arquivo={arquivo}/> : tipo === 'audio' ? (
                                <AudioCard
                                    key={arquivo.id_arquivo_atendimento}
                                    arquivo={arquivo}
                                    selecionado={getValues(resolverNomeFormulario(arquivo.id_arquivo_atendimento))}
                                    registerProps={register(resolverNomeFormulario(arquivo.id_arquivo_atendimento))}
                                    onExcluir={excluirArquivo}
                                />
                            ) : <Anexo arquivo={arquivo}/>}
                        </div>
                    ))}
                </Row>
                <Row className="justify-content-end mr-0 mt-3">
                <Button type="submit" style={{ backgroundColor: 'var(--dommus-color)' }} className="border-0">
                    <Icon icon={sendOutlined} color="white"/> Enviar Selecionados
                </Button>
            </Row>
            </>) : (
                <Alert variant="warning" className="text-center">
                    <FontAwesomeIcon icon={faExclamationTriangle}/> {`${tipo === 'imagem' ? 'Nenhuma imagem salva' : tipo === 'audio' ? 'Nenhum áudio salvo' : 'Nenhum anexo salvo'} até o momento.`}
                </Alert>
            )}
        </DommusToggle>
        <DommusToggle
            title={`Salvar ${tipo === 'imagem' ? 'Imagens' : tipo === 'audio' ? 'Áudios' : 'Anexos'}`}
            toggle={toggleSalvarArquivosAberto}
            className="labels"
            bodyClass="overflow-auto"
            callback={() => setToggleSalvarArquivosAberto(toggleAberto => !toggleAberto)}
        >
            <Form>
                {tipo === 'audio' && (
                    <Form.Group className="mb-2">
                        <Form.Label style={{ color: '#6c757d', fontSize: '0.85rem', fontWeight: '500', marginBottom: '0.25rem' }}>
                            Descrição <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Informe uma descrição para o áudio"
                            value={descricaoAudio}
                            isInvalid={descricaoAudioInvalida}
                            onChange={(e) => {
                                setDescricaoAudio(e.target.value)
                                if(e.target.value.trim()) setDescricaoAudioInvalida(false)
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            Informe uma descrição para o áudio antes de salvar.
                        </Form.Control.Feedback>
                    </Form.Group>
                )}
                <Anexos
                    listaAnexos={arquivosSalvar}
                    setListaAnexos={setArquivosSalvar}
                    filesTypes={tipo === 'imagem' ? 'image/jpeg, image/png, image/gif, image/bmp, image/svg+xml, image/webp' : tipo === 'audio' ? 'audio/*' : '*'}
                    multiplos={tipo !== 'audio'}
                />
                <div className="area_btn_anexar">
                    <Button className="anexarImagem" onClick={() => salvarImagens()}>
                        Enviar <Icon icon={sendOutlined} color="white" />
                    </Button>
                </div>
            </Form>
        </DommusToggle>
    </Form>
}
